import api from '@/api';

import {
  VehicleFragaListResponse,
  VehicleFragaResponse,
} from './Vehicle.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/vehicle`;

export async function getVehicleFragaList(licensePlate?: string) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${licensePlate}/list`,
    null,
  )) as unknown;

  return result as VehicleFragaListResponse;
}

export async function getVehicleFragaByChassi(
  chassi?: string,
): Promise<VehicleFragaResponse> {
  const result = (await api.get(
    `${CONTROLLER_URL}/chassi/${chassi}`,
    null,
  )) as unknown;

  return result as VehicleFragaResponse;
}
